<template>
  <v-container
    fluid
  >
    <vault-transactons-table
      :transactions="transactions"
      :loading="loading"
      @refreshTransactions="loadTransactions()"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import moment from 'moment';

import { VaultTransactionsTable } from '@/components/vault';


export default {
  name: 'VaultTransactions',
  components: {
    'vault-transactons-table': VaultTransactionsTable,
  },
  computed: {
    ...mapState({
      loading: state => state.vaultTransactionsStore.loading,
      transactions: state => state.vaultTransactionsStore.vaultTransactions,
    }),
    ...mapGetters(['getVaultTransactionsPagination']),
  },
  watch: {
    '$route.query': {
      handler(val, oldVal) {
        this.setPagination();
        this.loadTransactions();
      },
    },
  },
  async beforeMount() {
    const last3Days = moment().subtract(7, 'days');
    this.setPagination();
    await this.getVaultAssets(300);
    await this.getStatusCount({ status: 'error', date: last3Days });
    await this.getStatusCount({ status: 'queued', date: null });
    await this.getStatusCount({ status: 'processing', date: null });
    await this.getStatusCount({ status: 'pending', date: null });

    if (this.$route.query.page) {
      this.loadTransactions();
    }
  },
  beforeDestroy() {
    this.reset();
  },
  methods: {
    ...mapActions(['getVaultTransactions', 'getStatusCount', 'reset', 'setVaultTransactionsPagination', 'getVaultAssets']),
    setPagination() {
      // check url params and update vault store
      const pagination = {};
      pagination.descending = this.$route.query.dir
        ? this.$route.query.dir === 'desc'
        : this.getVaultTransactionsPagination.descending;
      pagination.page = +this.$route.query.page || +this.getVaultTransactionsPagination.page;
      pagination.rowsPerPage = +this.$route.query.rowsPerPage || +this.getVaultTransactionsPagination.rowsPerPage;
      pagination.sortBy = this.$route.query.sortBy || this.getVaultTransactionsPagination.sortBy;
      this.setVaultTransactionsPagination(pagination);
    },
    loadTransactions() {
      const { search, status, token } = this.$route.query;
      // console.info('loadTransactions', { search, filters: { status, token } });
      clearTimeout(this.loadTransactionsTimeout);
      this.loadTransactionsTimeout = setTimeout(() => this.getVaultTransactions({ search, filters: { status, token } }), 1000);
    },
  },
};
</script>


<style lang="scss" scoped>
.vault-transactions-view-container{
  max-width: 1500px;
}
</style>



// WEBPACK FOOTER //
// src/views/vault/VaultTransactions.vue